import { ApiClient } from '@travel/api-client';

import { SearchAreasResponse } from 'SearchAreas-Types';

import { MONTEROSA_API_TIMEOUT } from 'store/utils';

export const fetch = (
  http: ApiClient,
  departureArea?: string,
  accommodationArea?: string,
): Promise<SearchAreasResponse> =>
  http.post('/monterosa-api-dp/dp/jrdp/v2/areas', {
    ignoreCommonErrorHandler: true,
    values: {
      departureArea,
      accommodationArea,
    },
    timeout: MONTEROSA_API_TIMEOUT,
  });
